import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=b535e118&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Form.vue?vue&type=style&index=1&id=b535e118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b535e118",
  null
  
)

export default component.exports